export default function Machines_B_6 (number = 1) {
  return {
    name: '储液灌',
    icon: '/static/img/machines/b6.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_6.js